import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import {
  QuestionNumberSize,
  QuestionNumberSizeProps,
} from '../QuestionNumberSize/QuestionNumberSize';
import { typeStyles } from './typeStyles';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  border-radius: 20px;
  cursor: pointer;
  user-select: none;

  ${typeStyles}
`;

interface QuestionNumberProps extends Pick<QuestionNumberSizeProps, 'size'> {
  type?: 'default' | 'correct' | 'in-progress';
  text?: string;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export const QuestionNumber = (props: QuestionNumberProps) => {
  const { type = 'default', size, text, selected = false, disabled = false, onClick } = props;

  return (
    <Container
      className={cl('question-number', type, { selected, disabled })}
      onClick={() => !disabled && onClick?.()}
    >
      <QuestionNumberSize size={size}>
        <ResponsiveTypography.Text variant="semi-bold/14-20">{text}</ResponsiveTypography.Text>
      </QuestionNumberSize>
    </Container>
  );
};
